<template>
  <b-form class="g2w-link-form">
    <b-form-group
      :id="formGroupId"
      label="Enter registration or join link"
      :label-for="inputId">
      <b-form-input type="text" class="input-lg"
        autocomplete="off"
        autofocus
        :id="inputId" v-model.trim="userInput">
      </b-form-input>
    </b-form-group>

    <b-button v-if="action === 'register' || action === 'recording'"
      variant="primary" @click="register">
      Start registration
    </b-button>
    <b-button v-else-if="action === 'join'"
      variant="primary" @click="join">
      Join webinar
    </b-button>
  </b-form>
</template>

<script>
import UrlParse from 'url-parse';

const G2WLinkForm = {
  name: 'G2WLinkForm',

  props: {
    initialValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      formGroupId: `landing-group-${this._uid}`,
      inputId: `landing-input-${this._uid}`,
      userInput: '',
      recordingKey: '',
      webinarKey: '',
      recurrenceKey: '',
      registrantKey: '',
      action: ''
    };
  },

  created() {
    this.userInput = this.initialValue;
  },

  watch: {
    userInput(newValue) {
      if (/^\d+$/.test(newValue)) {
        this.webinarKey = newValue;
        this.action = 'register';
      } else {
        // url
        const url = new UrlParse(newValue);

        // match a register, join or recording link
        // examples:
        // https://attendeeed1.g2w.test.expertcity.com/register/5475481426669820674
        // https://globaled1.g2w.test.expertcity.com/join/5475481426669820674/137197190
        // https://globaled1.g2w.test.expertcity.com/sjoin/1061141258989726978/984510656
        // https://attendeeed1.g2w.test.expertcity.com/recording/6596584170562714881
        const match = /\/(register|rt|s?join|recording)\/(\d+)\/?(\d*)/i.exec(
          url.pathname
        );

        if (match) {
          this.$store.commit('g2wEnv/setFromHostName', {
            hostname: url.hostname
          });

          this.action = match[1].toLowerCase();
          switch (this.action) {
            case 'recording':
              this.recordingKey = match[2];
              break;
            case 'register':
              this.webinarKey = match[2];
              break;
            case 'rt':
              this.recurrenceKey = match[2];
              break;
            case 'join':
            case 'sjoin':
              this.action = 'join';
              this.webinarKey = match[2];
              this.registrantKey = match[3];
              break;
            default:
              this.logger.log('unknown action', { action: this.action });
              break;
          }

          if (this.initialValue && this.userInput === this.initialValue) {
            this.takeImmediateAction();
          }
        } else {
          this.action = '';
          if (newValue) {
            this.logger.log('unexpected url', newValue);
          }
        }
      }
    }
  },

  methods: {
    takeImmediateAction() {
      if (/join/.test(this.action)) {
        this.join();
      } else {
        this.register();
      }
    },

    register() {
      if (this.recordingKey) {
        this.$router.push({
          name: 'recording-registration',
          params: { recordingKey: this.recordingKey }
        });
      } else {
        this.$router.push({
          name: 'registration',
          params: {
            webinarKey: this.webinarKey,
            recurrenceKey: this.recurrenceKey
          }
        });
      }
    },

    join() {
      this.$router.push({
        name: 'attendance',
        params: {
          webinarKey: this.webinarKey,
          registrantKey: this.registrantKey
        }
      });
    }
  }
};

export default G2WLinkForm;
</script>
